module.exports = __webpack_public_path__ + "img/icon_government.525ad56c.svg";